if (!customElements.get('header-menu-drawer')) {
  customElements.define('header-menu-drawer', class extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.header-menu-drawer__trigger');
      this.dialog = this.querySelector('dialog');
      if (!this.trigger || !this.dialog || this.events) return;

      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.trigger.addEventListener('click', () => {
        if (this.dialog.open) return;
        document.body.classList.add('header-menu-drawer-open');
        this.dialog.showModal();
        this.trigger.setAttribute('aria-expanded', 'true');
      }, options);
      this.dialog.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-menu-toggle]');
        if (toggle && window.innerWidth < 1200) {
          const submenu = document.getElementById(toggle.getAttribute('aria-controls'));
          if (!submenu || !this.dialog.contains(submenu)) return;
          const expanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', String(!expanded));
          submenu.hidden = expanded;
          return;
        }
        if (event.target === this.dialog || event.target.closest('[data-menu-close], a')) {
          this.dialog.close();
        }
      }, options);
      this.dialog.addEventListener('close', () => {
        if (this.dialog.open) return;
        this.trigger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('header-menu-drawer-open');
      }, options);
      window.addEventListener('resize', () => {
        if (this.dialog.open && !this.hasAttribute('data-desktop-drawer') && window.innerWidth >= 1200) {
          this.dialog.close();
        }
      }, options);
    }

    disconnectedCallback() {
      if (this.dialog?.open) {
        this.dialog.close();
        this.trigger?.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('header-menu-drawer-open');
      }
      this.events?.abort();
      this.events = null;
    }
  });
}
